import type { ReactElement, ReactNode } from 'react'

import styles from './emptyState.module.scss'

export type EmptyStateProps = {
  /** What is not there, in the plant's own words ("Aún no hay grupos"). */
  title: string
  /** What to do about it, when there is something to do. */
  message?: string
  /** The action that fixes it — typically the same Button as the screen's header. */
  action?: ReactNode
}

/**
 * "There is nothing here", and visibly NOT "we could not load it" (`ErrorState`)
 * nor "we are loading it" (`Spinner`). The three are distinct on purpose: a
 * plant screen that shows an empty list for a failed request tells an operator
 * that there is no work.
 */
export const EmptyState = ({ title, message, action }: EmptyStateProps): ReactElement => (
  <div className={styles['empty-state']}>
    <p className={styles['empty-state__title']}>{title}</p>
    {message !== undefined && <p className={styles['empty-state__message']}>{message}</p>}
    {action !== undefined && <div className={styles['empty-state__action']}>{action}</div>}
  </div>
)
